module.exports = __webpack_public_path__ + "assets/img/thumb-Kaplan-Professional-Pillar-Page-Resource.9f8a69da.webp";